var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 8.16675C6.125 7.6835 6.51675 7.29175 7 7.29175H21C21.4832 7.29175 21.875 7.6835 21.875 8.16675C21.875 8.65 21.4832 9.04175 21 9.04175H7C6.51675 9.04175 6.125 8.65 6.125 8.16675Z",
    fill: "#2F3237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 14C6.125 13.5168 6.51675 13.125 7 13.125H17.5C17.9832 13.125 18.375 13.5168 18.375 14C18.375 14.4832 17.9832 14.875 17.5 14.875H7C6.51675 14.875 6.125 14.4832 6.125 14Z",
    fill: "#2F3237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.125 19.8335C6.125 19.3502 6.51675 18.9585 7 18.9585H21C21.4832 18.9585 21.875 19.3502 21.875 19.8335C21.875 20.3167 21.4832 20.7085 21 20.7085H7C6.51675 20.7085 6.125 20.3167 6.125 19.8335Z",
    fill: "#2F3237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.d7191034ff2db5deeeb76c30151199e9.svg";
export { ForwardRef as ReactComponent };